// extracted by mini-css-extract-plugin
module.exports = {"root":"c6e8ba5398--root--vz2Zy","label":"c6e8ba5398--label--3Iv5c"};